import { memo, type PropsWithChildren } from 'react';

import { MainSideNavSeparator } from '~/components/v2/components/workspace/main-side-nav/MainSideNavSeparator';

export type MainSideNavSectionProps = PropsWithChildren<{
  'aria-label': string;
  id: string;
}>;

export const MainSideNavSection = memo(({ 'aria-label': ariaLabel, children, id }: MainSideNavSectionProps) => {
  return (
    <section
      aria-label={ariaLabel}
      className="hidden flex-col has-[[data-item-id]]:flex"
      data-section-id={id}
      data-testid="MAIN_SIDE_NAV_SECTION"
    >
      <MainSideNavSeparator />
      {children}
    </section>
  );
});

MainSideNavSection.displayName = 'MainSideNavSection';
